<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-14 17:42:16
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-07-16 10:55:21
 * @name: 视口
 * @Description: 视口
 * @FilePath: \backstage\src\components\public\layout-normal.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="layout-bac">
    <div class="layout-card" :style="{ minHeight: cardMinHeight }">
      <div class="layout-content">
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "layoutNormal",
  computed: {
    cardMinHeight() {
      const headHeight = this.$scssVars['Vars-head-height']; //头部高度
      const padding = this.$scssVars['Var-module-card-padding']; //卡片padding
      let route = this.$route.name; //当前路由
      let tabs = this.$store.state.indexHead.tabs; //页面头部tabs
      let childTabsHeight = '0px';
      tabs.findIndex(x => x.children.findIndex(y => y.name === route) > -1) > -1 &&  (childTabsHeight = this.$scssVars['Vars-childTabs-height']);
      return `calc(100vh - ${headHeight} - ${childTabsHeight} - 2 * ${padding})`;
    },
  },
};
</script>
<style lang="scss" scoped>
.layout-bac {
  box-sizing: border-box;
  width: 100%;
  padding: $Var-module-card-padding;
  .layout-card {
    width: 100%;
    box-shadow: $Vars-boxShadow-normal;
    background: $Vars-base-color-white;
    border-radius: $Vars-border-radius-normal;
    @extend .extend-flex-normal;
    .layout-content{
      @extend .extend-content;
    }
  }
}
</style>
